import type { RealtimeConfig } from "@kalaporssi/client";

/** Runtime configuration, generated at deploy time into /config.json (SPEC §15). */
export interface AppConfig {
  stage: string;
  /** "/api" behind CloudFront, or the execute-api URL for local development. */
  apiBaseUrl: string;
  realtime: RealtimeConfig;
  cognito: { domain: string; clientId: string };
}

let config: AppConfig | null = null;

export async function loadConfig(): Promise<AppConfig> {
  const res = await fetch("/config.json", { cache: "no-store" });
  if (!res.ok) throw new Error(`config.json: HTTP ${res.status}`);
  config = (await res.json()) as AppConfig;
  return config;
}

export function getConfig(): AppConfig {
  if (!config) throw new Error("config not loaded");
  return config;
}
